import { render, staticRenderFns } from "./viewModel.vue?vue&type=template&id=50d5c634&scoped=true&"
import script from "./viewModel.vue?vue&type=script&lang=js&"
export * from "./viewModel.vue?vue&type=script&lang=js&"
import style0 from "./viewModel.vue?vue&type=style&index=0&id=50d5c634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5c634",
  null
  
)

export default component.exports